/* istanbul ignore file */
import { connect } from 'react-redux'
import ConnectedRentalCarProcessContainer from './ConnectedRentalCarProcessContainer'
import { requestUser } from '../../actions/user'
import { contactRentalCar } from '../../actions/rentalCarContract'
import { userDataSelector, isUserLoadedSelector } from '../../selectors/user'

function mapStateToProps (state) {
    return {
        user: userDataSelector(state),
        userLoaded: isUserLoadedSelector(state),
    }
}

export default connect(mapStateToProps, {
    requestUser,
    contactRentalCar,
})(ConnectedRentalCarProcessContainer)
